var map = {
	"./coach_1.gif": "1e7c",
	"./coach_2.gif": "826e",
	"./coach_3.gif": "a8da",
	"./player_1.gif": "5b1c",
	"./player_2.gif": "a814",
	"./player_3.gif": "391b",
	"./player_4.gif": "7fcc",
	"./player_5.gif": "1a8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d4f0";